import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

function SectionTransition({ children }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'start 0.3'],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.6, 1], [0, 0.5, 1]);
  const scale = useTransform(scrollYProgress, [0, 1], [0.93, 1]);
  const y = useTransform(scrollYProgress, [0, 1], [80, 0]);

  return (
    <div ref={ref}>
      <motion.div style={{ opacity, scale, y, willChange: 'transform, opacity' }}>
        {children}
      </motion.div>
    </div>
  );
}

export default SectionTransition;
